export default "__VITE_ASSET__DjsOzIJO__"